import { Building2, Users, Shield } from "lucide-react";
import { FeaturesGrid } from "../shared/FeaturesGrid";

export const BusinessFeatures = () => {
  const features = [
    {
      icon: Building2,
      title: "Industry Expertise",
      description: "Specialized knowledge across various business sectors."
    },
    {
      icon: Users,
      title: "Dedicated Team",
      description: "Personal account managers for your business needs."
    },
    {
      icon: Shield,
      title: "Complete Protection",
      description: "Comprehensive coverage for all aspects of your business."
    }
  ];

  return (
    <FeaturesGrid
      title="Business Insurance Excellence"
      description="Partner with experts who understand your business needs and provide comprehensive protection."
      features={features}
    />
  );
};